export default __webpack_public_path__ + "static/media/PRO-ZD801.68bf4903.png";